import { createAuthClient } from 'better-auth/client';
import { emailOTPClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  // In dev: use VITE_API_URL (e.g. http://localhost:3001)
  // In production (same-origin container): omit → Better Auth uses current origin
  baseURL: import.meta.env['VITE_API_URL'] || undefined,
  plugins: [emailOTPClient()],
});

export type Session = typeof authClient.$Infer.Session;
export type User = typeof authClient.$Infer.Session.user;
